import { useAtomValue } from 'jotai';

import * as state from '../../_state/loadDetails.state';
import { PhotoAlbum } from '../_shared/PhotoAlbum';

export const EntityLoadTabPhotos = () => {
  const { data: loadPhotos } = useAtomValue(state.$loadPhotos);
  const { data: materialPhotos } = useAtomValue(state.$loadMaterialPhotos);

  return (
    <div className="@EntityLoadTabPhotos flex flex-col gap-2">
      <PhotoAlbum photos={loadPhotos} title="Load Photos" />
      <hr className="my-4 border-neutral/10" />
      <PhotoAlbum photos={materialPhotos} title="Material Photos" />
    </div>
  );
};
